import CleverAnchor from './CleverAnchor';

export default CleverAnchor;
